import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  CardBody,
  Input,
  Col,
  Container,
  Row,
  Badge,
  Button,
} from "reactstrap";

import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import GeneralCrudModal from "./GeneralCrudModal";
import CRUDService from "../API_RELATED/CRUDService";
import UserDetailModal from "./UserDetailModal";
import toast from "react-hot-toast";
import DeleteModal from "./DeleteModal";

const GeneralAdminMain = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [showSearchedData, setShowSearchedData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  const [isEdit, setIsEdit] = useState(false)
  const [userDetailModalState, setUserDetailModalState] = useState({
    isOpen: false,
    data: {},
  });
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    row: {},
  });

  useEffect(() => {
    const testCall = async () => {
      try {
        const data = {
          trackEntity: true,
          page: 1,
          pageSize: 10,
        };
        const res = await CRUDService.getList(data);
        console.log(res);
        setData(res.data);
        setShowSearchedData(res.data);
        setLoading(false);
      } catch (err) {
        console.log("error on getting data. ERR: ", err);

        toast.error(
          err.response.data
            ? err.response.data
            : "error occured while fetchiing data"
        );
      }
    };

    if (loading == true) {
      testCall();
    }
  }, [loading]);

  const handleAddUser = () => {
    setEditUserData({});
    // setAddUser(prev=> !prev)
    setIsOpen((prev) => !prev);
    setIsEdit(false)
  };

  const handleEdit = (row) => {
    setEditUserData(row);
    setIsOpen((prev) => !prev);
    setIsEdit(true)
    // setAddUser(true)
  };

  const toggleFunc = () => {
    setIsOpen((prev) => !prev);
    if(editUserData){
      setEditUserData({})
    }
    
  };

  const toggleDeleteModal = () => {
    setDeleteModal((prev) => ({ ...prev, isOpen: !deleteModal.isOpen }));
  };

  const toggleUserDetail = () => {
    setUserDetailModalState((prev) => ({
      ...prev,
      isOpen: !userDetailModalState.isOpen,
    }));
  };

  const handleAPIDelete = async () => {
    console.log("here in handle");
    try {
      const res = await CRUDService.delete(deleteModal.row.id);
      console.log(res);
      setShowSearchedData(res.data);
      setLoading(true);
      setDeleteModal((prev) => ({ ...prev, isOpen: false }));

      toast.success("Deleted Successfully!");
    } catch (err) {
      console.log("error while deleting, err: ", err.response?.data);

      toast.error(
        err.response?.data?.message ? err.response?.data?.message : "error occured while deleting"
      );
    }
  };

  const handleUserDetail = async (row) => {
    try {
      const res = await CRUDService.getUserDetail(row.id);
      console.log(res);
      setUserDetailModalState({
        isOpen: true,
        data: res,
      });
    } catch (err) {
      console.log("error while getting user detail. ERR: ", err);

      toast.error(
        err.response.data
          ? err.response.data
          : "error occured while getting user detail"
      );
    }
  };

  const columns = [
    {
      name: "S.N",
      width: "80px",
      sortable: true,
      cell: (row, index) => <div> {index + 1} </div>,
    },

    {
      name: "Name",
      selector: (row) => row.firstName + row.lastName,
      // cell: (row, index) => (
      //   <div onClick={() => handleUserDetail(row)}>
      //     {" "}
      //     {`${row.firstName} ${row.lastName}`}
      //   </div>
      // ),
      // sortable: true,
      grow: 2,
    },

    {
      name: "Phone Number",
      selector: (row) => row.phoneNumber,
      sortable: true,
      grow: 2,
    },

    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
      grow: 2,
    },

    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      grow: 3,
    },

    {
      name: <span className="fw-bold">Roles</span>,
      selector: (row) => row.roles,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "5px",
            padding: "5px 0",
          }}
        >
          {row.roles &&
            row.roles.map((role, index) => (
              <Badge
                key={index}
                color="primary"
                className="me-1"
                style={{
                  padding: "5px 8px",
                  fontSize: "12px",
                }}
              >
                {role}
              </Badge>
            ))}
        </div>
      ),
      sortable: true,
      grow: 2,
    },

    {
      name: <span className="fw-bold">Action</span>,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Button
            color="warning rounded-circle p-1"
            size="sm"
            onClick={() => handleEdit(row)}
            style={{ width: "30px", height: "30px" }}
          >
            {" "}
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger rounded-circle p-1"
            size="sm"
            onClick={() => setDeleteModal({ isOpen: true, row: row })}
            style={{ width: "30px", height: "30px" }}
          >
            {" "}
            <i className="bx bx-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  const searchList = (e) => {
    if (e == "") {
      setShowSearchedData(data);
    }
    console.log(data);

    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        // return (el.firstName.toLowerCase().indexOf(query.toLowerCase()) ) !== -1
        return (
          el.firstName.toLowerCase().includes(query.toLowerCase()) ||
          el.lastName.toLowerCase().includes(query.toLowerCase())
        );
      });
    };

    let filterData = filterItems(data, inputVal);
    setShowSearchedData(filterData);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb pageTitle="User Management" />

          <Card>
            <CardBody>
              <Row>
                <Col sm={4}>
                  {!addUser ? (
                    <div className="search-box">
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="search by name"
                        onChange={(e) => searchList(e.target.value)}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  ) : (
                    ""
                  )}
                </Col>

                <Col sm={8} className="text-end">
                  <div className="search-box">
                    <Button onClick={handleAddUser}>
                      {addUser ? "Back" : "+ New"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CustomDataTable
                    responsive
                    striped
                    pagination
                    fixedHeader
                    persistTableHead
                    progressPending={loading}
                    columns={columns}
                    data={showSearchedData ? showSearchedData : []}
                    customStyles={{
                      headCells: {
                        style: {
                          fontSize: "0.93rem",
                          fontWeight: 610,
                        },
                      },
                      rows: {
                        style: {
                          fontSize: "0.9rem",
                        },
                      },
                    }}
                    progressComponent={
                      <div className="my-3">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                          ariaLabel="triangle-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <GeneralCrudModal
          isOpen={isOpen}
          toggle={toggleFunc}
          editUserData={editUserData}
          setLoading={setLoading}
          setEditUserData={setEditUserData}
          isEdit={isEdit}
        />

        <UserDetailModal
          isOpen={userDetailModalState.isOpen}
          toggle={toggleUserDetail}
          data={userDetailModalState.data}


        />

        <DeleteModal
          show={deleteModal.isOpen}
          onCloseClick={toggleDeleteModal}
          onDeleteClick={handleAPIDelete}
        />
      </div>
    </React.Fragment>
  );
};

export default GeneralAdminMain;
